import { render, staticRenderFns } from "./ProductsSale.vue?vue&type=template&id=50ff9a34&"
import script from "./ProductsSale.vue?vue&type=script&lang=js&"
export * from "./ProductsSale.vue?vue&type=script&lang=js&"
import style0 from "./ProductsSale.vue?vue&type=style&index=0&id=50ff9a34&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports